/** Ports `currentRound()`. Fixed 15-minute blocks aligned to the Unix epoch. */
export function currentRound(nowMs = Date.now()) {
    const block = 15 * 60 * 1000;
    const startMs = Math.floor(nowMs / block) * block;
    return {
        id: String(Math.floor(startMs / block)),
        startMs,
        closeMs: startMs + block,
        secondsRemaining: Math.max(0, Math.floor((startMs + block - nowMs) / 1000)),
    };
}
/** Ports `countdownText()`. */
export function countdownText(seconds) {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}m ${String(s).padStart(2, '0')}s`;
}
//# sourceMappingURL=round.js.map